export const GET_MEMBERSHIP_NOW_YOUR_COMMUNITY_SUCCESS =
  'GET_MEMBERSHIP_NOW_YOUR_COMMUNITY_SUCCESS';
export const GET_MEMBERSHIP_NOW_YOUR_COMMUNITY_FAILURE =
  'GET_MEMBERSHIP_NOW_YOUR_COMMUNITY_FAILURE';

export const POST_MEMBERSHIP_NOW_YOUR_COMMUNITY_SUCCESS =
  'POST_MEMBERSHIP_NOW_YOUR_COMMUNITY_SUCCESS';
export const POST_MEMBERSHIP_NOW_YOUR_COMMUNITY_FAILURE =
  'POST_MEMBERSHIP_NOW_YOUR_COMMUNITY_FAILURE';
